<template>
    <div class="cl-checkbox">
        <div class="cl-checkbox-item" :class="{checked: val.indexOf(o) >= 0}" v-for="(o, i) in options" :key="i" @click="handleClick(o)">
            <div class="cl-checkbox-input"></div>
            <div class="cl-checkbox-title">{{o}}</div>
        </div>
    </div>
</template>

<script>
    import mixins from "./mixins";
    export default {
        name: "clCheckbox",
        model: {
            event: 'change'
        },
        mixins: [mixins],
        props: {
            value: [String, Array],
            options: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        created() {
            if(this.value) {
                if(Array.isArray(this.value)) {
                    this.val = [].concat(this.value);
                } else {
                    this.val = [].concat(this.value.split(","));
                }
            }
        },
        data() {
            return {
                val: []
            }
        },
        methods: {
            handleClick(o) {
                let val = this.val;
                let i = val.indexOf(o);
                if(i >= 0) {
                    val.splice(i, 1);
                } else {
                    val.push(o);
                }
                this.val = val;
                if(Array.isArray(this.value)) {
                    this.$emit("change", val);
                } else {
                    this.$emit("change", val.join(","));
                }
                this.notifyCheck();
            }
        }
    }
</script>

<style lang="less">
    .cl-checkbox-item {
        display: flex;
        align-items: center;
        &:not(:first-of-type) {
            margin-top: 12px;
        }
        &.checked {
            .cl-checkbox-input {
                background-color: var(--main-color);
                border-color: var(--main-color);
                color: var(--back-font-color);
                font-size: 24px;
                &::before {
                    content: '\e632';
                    font-family: fonticon;
                }
            }
        }
    }
    .cl-checkbox-input {
        width: 32px;
        height: 32px;
        border: var(--border);
        text-align: center;
        line-height: 32px;
    }
    .cl-checkbox-title {
        margin-left: 20px;
        color: var(--title-font-color);
    }
</style>
